import React from "react";

import styles from "./CritterTile.module.css";

const CheckMarkIcon = () => {
  return (
    <div className={styles.check}>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 600 600">
        <g>
          <path d="M270.75,385.17h0c-13.31-29.24-76.4-93.28-76.4-93.28-6.44-21.33-20.41-22.5-26.15-11.61-8.62,16.35-20.24,48-29.22,64.1-3.68,6.59-4.14,17.61-1.88,23.1,0,0,72.79,48.08,108,124.82,9.67,21.07,21,11.33,41.24,3.25,18.17-7.25,30.52-12,29.8-20.94,0,0,51-206.72,185.15-326.3,7.47-6.66,5.55-23.67,9.9-35.48,3.16-8.56,10-16,5.7-17.1-8.9-2.26-21.86.29-42.63,15.13C409.71,157,349.24,234.93,270.75,385.17Z" />
        </g>
      </svg>
    </div>
  );
};

export default CheckMarkIcon;
